import React, { FC } from "react";
import { OidcLoginSilent } from "./oidc/OidcLoginSilent";

export const LoginSilent: FC = () => {
  return <OidcLoginSilent />;
};
